import {CONDITION_STATES_TO} from "../../../enums/conditionStatesTo";
import getType from "./getType";
import {CONDITION_STATES} from "../../../enums/conditionStates";

export default {
  mixins: [
    getType
  ],
  methods: {
    getState(type, first, second) {
      switch (type) {
        case CONDITION_STATES.IS_EQUAL_TO:
          if (typeof first == 'object' && first.includes) {
            return first.includes(second);
          } else {
            return first === second
          }
        case CONDITION_STATES.IS_NOT_EQUAL_TO:
          if (typeof first == 'object' && first.includes) {
            return !first.includes(second);
          } else {
            return first !== second
          }
        case CONDITION_STATES.IS_EMPTY:
          return first === ''
        case CONDITION_STATES.IS_FILLED:
          return first !== undefined && first !== ''
        case CONDITION_STATES.IS_LESS_THAN:
          return parseFloat(first) < parseFloat(second)
        case CONDITION_STATES.IS_GREATER_THAN:
          return parseFloat(first) > parseFloat(second)
      }
      return false;
    },

    getStateForCondition(cond){
      let firstValue = this.formData[cond.field];
      let secondValue = parseInt(cond.to) === CONDITION_STATES_TO.ANOTHER_FIELD ? this.formData[cond.targetField] : cond.value;

      if (this.getType(cond.field) === 'date') {
        firstValue = moment(firstValue);
        secondValue = moment(secondValue);
      }

      if (this.getType(cond.field) === 'currency') {
        firstValue = firstValue.replace('$', '');
        secondValue = secondValue.replace('$', '');
      }

      return this.getState(parseInt(cond.state), firstValue, secondValue)
    },

    // removes all properties from given object using Vue.$delete to ensure reactivity is working properly
    clearObject(o) {
      Object.keys(o).forEach(key => this.$delete(o, key))
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/formRender/reusable/conditionsCommon.js